import React from 'react'
import { formatPrice } from 'common/helpers'
import { FormattedHTMLMessage, FormattedMessage } from 'sb-react-intl'

import messages from './messages'
import s from './MonthOption.scss'


// TODO recurly. use "billingPeriod" - added on 6/8/20 by pavelivanov
const MonthOption = ({ option: { productPrice, billingPeriod, monthCount, totalPrice } }) => (
  <div className={s.option}>
    <FormattedMessage {...messages.title} values={{ count: monthCount || billingPeriod }} />
    <FormattedHTMLMessage
      className={s.totalPrice}
      tag="div"
      {...messages.totalPrice}
      values={{ value: formatPrice(totalPrice, true) }}
    />
    <FormattedMessage
      className={s.scentPrice}
      tag="div"
      {...messages.scentPrice}
      values={{ value: formatPrice(productPrice, true) }}
    />
  </div>
)


export default MonthOption
